<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <MobileFooterNav v-if="isShowFooterNav"/>
    <BackTop class="hidden-xs-only" />
  </div>
</template>

<script>
import MobileFooterNav from '@/views/h5/MobileFooterNav.vue'
import Home from '@/views/home/Home.vue'
export default {
  name: 'App',
  components: {
    Home,
    MobileFooterNav,
  },
  data() {
    return {
      isShowFooterNav: false // 默认选中首页
    };
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    '$route.path'(newPath) {
      const routes = ['/app_home', '/app_activation', '/app_search', '/app_mine','/app_myClub','/app_after','/app_step','/app_edit_info','/app_benefits','/benefits_use'];
      if(routes.indexOf(newPath)>= 0){
        this.isShowFooterNav = true;
      }else{
        this.isShowFooterNav = false;
      }
    }
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');
</style>
